import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { produce } from 'immer';
import { RootState } from '../store';
import { TimageINT } from './gameObjectSlice';


export interface SeenWords {
    [key: string]: string;
}
export interface TAdvanceINT {
    canAdvance: boolean,
    promise?: any,
    clicked?: number,
    skipping?: boolean;
    keyPressed?: string | undefined,
    seenWords: SeenWords;
    globalSeenScenarios?: string[];
    globalSeenImages?: string[];
    // sceneName: string,
    // rollback: RollbackType
}

const AdvanceSlice = createSlice({
    name: 'advance',
    initialState: { canAdvance: false, clicked: 0, seenWords: {} } as TAdvanceINT,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setAdvance: (state, { payload }: PayloadAction<Partial<TAdvanceINT>>) => {
            return produce(state, draft => {

                return { ...draft, ...payload };
            });
        },
        setClickedScreen: (state) => {
            return produce(state, draft => {
                draft.clicked = draft.clicked! + 1;
                draft.keyPressed = undefined;
                draft.skipping = false;

            });
        },
        setSeenWord: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                if (payload) {
                    // store can't accept hashed map so using fake object for quick access of words
                    if (!draft.seenWords) {
                        draft.seenWords = {};
                    }
                    draft.seenWords[payload] = payload;
                }
            });
        },
        setSeenWords: (state, { payload }: PayloadAction<SeenWords>) => {
            return produce(state, draft => {
                if (payload) {
                    draft.seenWords = payload;
                }
            });
        },
        setSeenImage: (state, { payload }: PayloadAction<TimageINT>) => {
            return produce(state, draft => {
                if (payload) {
                    if (!draft.globalSeenImages) { draft.globalSeenImages = []; }
                    if (!draft.globalSeenImages.includes(payload.key!)) {
                        draft.globalSeenImages.push(payload.key!);
                    }
                    payload.partialsToDisplay?.forEach(i => {
                        if (!draft.globalSeenImages!.includes(i.key!)) {
                            draft.globalSeenImages!.push(i.key!);
                        }

                    });
                }
            });
        },


    },

});

export const { setAdvance, setClickedScreen,
    setSeenWord,
    setSeenImage,
    setSeenWords } = AdvanceSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectAdvance = (state: RootState) => state.advance;
export const selectKeyPressed = (state: RootState) => state.advance.keyPressed;
export const selectGlobalSeenScenarios = (state: RootState) => state.advance.globalSeenScenarios;
export const selectClickedScreen = (state: RootState) => state.advance.clicked;


export default AdvanceSlice.reducer;
